'use client'

interface AuthOverlayLoaderProps {
    open: boolean;
    text?: string;
}

export function AuthOverlayLoader({open, text = "Lade Benutzerdaten..."}: AuthOverlayLoaderProps) {
    if (!open) {
        return null;
    }

    return (
        <div className={"fixed inset-0 z-[9999] bg-background/80 backdrop-blur-sm flex items-center justify-center"}>
            <div className={"flex flex-col items-center gap-4"}>
                <div className={"w-12 h-12 rounded-full border-4 border-primary/25 border-t-primary animate-spin"} />
                <span className={"text-sm text-foreground font-medium"}>
                    {text}
                </span>
            </div>
        </div>
    );
}

